import { platformApi } from '@lved/api-gateway';
import {
    GitHubRelease,
    LayoutMode,
    LVGL_PRO_DOCS_XML_INDEX_URL,
    LVGL_EDITOR_NEW_ISSUE_URL,
    LVGL_EDITOR_RELEASES_URL
} from '@lved/shared-core';
import { CommandContribution, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import { HelpMenuGroups } from '@theia-lved-core/browser/shell/menu-contribution';
import { injectable } from '@theia/core/shared/inversify';

export const LvglTopActionsCommands = {
    LAYOUT_CODE: { id: 'lvgl.topActions.layout.code', label: 'Code' },
    LAYOUT_DESIGN: { id: 'lvgl.topActions.layout.design', label: 'Design' },
    USER_RELEASE_NOTES: { id: 'lvgl.topActions.user.releaseNotes', label: 'Release Notes' },
    USER_DOCUMENTATION: { id: 'lvgl.topActions.user.documentation', label: 'Documentation' },
    USER_REPORT_ISSUE: { id: 'lvgl.topActions.user.reportIssue', label: 'Report Issue' },
    UPDATE: { id: 'lvgl.topActions.update', label: 'Update' }
} as const;

@injectable()
export class TopActionsCommandsContribution implements CommandContribution, MenuContribution {
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(LvglTopActionsCommands.LAYOUT_CODE, {
            execute: async () => {
                const { useUIStore } = await import('@lved/ui');
                useUIStore.getState().setLayoutMode(LayoutMode.CODE);
            }
        });
        commands.registerCommand(LvglTopActionsCommands.LAYOUT_DESIGN, {
            execute: async () => {
                const { useUIStore } = await import('@lved/ui');
                useUIStore.getState().setLayoutMode(LayoutMode.DESIGN);
            }
        });

        commands.registerCommand(LvglTopActionsCommands.USER_RELEASE_NOTES, {
            execute: () => platformApi.openExternal(LVGL_EDITOR_RELEASES_URL)
        });
        commands.registerCommand(LvglTopActionsCommands.USER_DOCUMENTATION, {
            execute: () => platformApi.openExternal(LVGL_PRO_DOCS_XML_INDEX_URL)
        });
        commands.registerCommand(LvglTopActionsCommands.USER_REPORT_ISSUE, {
            execute: () => platformApi.openExternal(LVGL_EDITOR_NEW_ISSUE_URL)
        });
        commands.registerCommand(LvglTopActionsCommands.UPDATE, {
            execute: async (release?: GitHubRelease) => {
                const { useUIStore } = await import('@lved/ui');
                useUIStore.getState().setUpdateRelease(release ?? null);
                useUIStore.getState().setUpdatePopupOpen(true);
            }
        });
    }

    registerMenus(menus: MenuModelRegistry): void {
        menus.registerMenuAction(HelpMenuGroups.RESOURCES, {
            commandId: LvglTopActionsCommands.USER_DOCUMENTATION.id,
            label: LvglTopActionsCommands.USER_DOCUMENTATION.label,
            order: '0'
        });
        menus.registerMenuAction(HelpMenuGroups.RESOURCES, {
            commandId: LvglTopActionsCommands.USER_RELEASE_NOTES.id,
            label: LvglTopActionsCommands.USER_RELEASE_NOTES.label,
            order: '1'
        });
        menus.registerMenuAction(HelpMenuGroups.RESOURCES, {
            commandId: LvglTopActionsCommands.USER_REPORT_ISSUE.id,
            label: LvglTopActionsCommands.USER_REPORT_ISSUE.label,
            order: '2'
        });
    }
}
